import appCtrl from 'components/app/appCtrl';
import homeCtrl from 'components/home/homeCtrl';
import aboutCtrl from 'components/about/aboutCtrl';
import browseCtrl from 'components/browse/browseCtrl';
import browseCityCtrl from 'components/browseCity/browseCityCtrl';
import browseVenuesCtrl from 'components/browseVenues/browseVenuesCtrl';
import browseEventsCtrl from 'components/browseEvents/browseEventsCtrl';
import eventCtrl from 'components/event/eventCtrl';
import faqCtrl from 'components/faq/faqCtrl';
import tableserviceCtrl from 'components/tableservice/tableserviceCtrl';
import errorNotFoundCtrl from 'components/errorNotFound/errorNotFoundCtrl';
import errorServerCtrl from 'components/errorServer/errorServerCtrl';
import checkoutCtrl from 'components/checkout/checkoutCtrl';
import receiptCtrl from 'components/receipt/receiptCtrl';
import signupCtrl from 'components/signup/signupCtrl';
import conciergeCtrl from 'components/concierge/conciergeCtrl';
import couponsCtrl from 'components/coupons/couponsCtrl';
import downloadCtrl from 'components/download/downloadCtrl';
import earnCreditCtrl from 'components/earnCredit/earnCreditCtrl';
import forgotPasswordCtrl from 'components/forgotPassword/forgotPasswordCtrl';
import resetPasswordCtrl from 'components/resetPassword/resetPasswordCtrl';
import searchCtrl from 'components/search/searchCtrl';
//curated list
import curatedListCtrl from 'components/curatedList/curatedListCtrl';
import curatedListHalloweenCtrl from 'components/curatedListsHalloween/curatedListsHalloweenCtrl';
import curatedListsNewYearsCtrl from 'components/curatedListsNewYears/curatedListsNewYearsCtrl';
//venue
import venueCtrl from 'components/venue/venueCtrl';
import venueEventsCtrl from 'components/venueEvents/venueEventsCtrl';
import venueInfoCtrl from 'components/venueInfo/venueInfoCtrl';
//account
import accountCtrl from 'components/account/accountCtrl';
import accountBookingCtrl from 'components/accountBooking/accountBookingCtrl';
import accountDashboardCtrl from 'components/accountDashboard/accountDashboardCtrl';
import accountFavoritesCtrl from 'components/accountFavorites/accountFavoritesCtrl';
import accountProfileCtrl from 'components/accountProfile/accountProfileCtrl';
import accountPromoCtrl from 'components/accountPromo/accountPromoCtrl';
import accountReviewCtrl from 'components/accountReview/accountReviewCtrl';
import accountReviewsCtrl from 'components/accountReviews/accountReviewsCtrl';
import accountTicketsCtrl from 'components/accountTickets/accountTicketsCtrl';
//membership
import membershipCtrl from 'components/membership/membershipCtrl';
import membershipStartCtrl from 'components/membershipStart/membershipStartCtrl';
import membershipLandingCtrl from 'components/membershipLanding/membershipLandingCtrl';
import membershipPerksCtrl from 'components/membershipPerks/membershipPerksCtrl';
import membershipSuccessCtrl from 'components/membershipSuccess/membershipSuccessCtrl';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('appCtrl', appCtrl);
  app.controller('homeCtrl', homeCtrl);
  app.controller('aboutCtrl', aboutCtrl);
  app.controller('browseCtrl', browseCtrl);
  app.controller('browseCityCtrl', browseCityCtrl);
  app.controller('browseVenuesCtrl', browseVenuesCtrl);
  app.controller('browseEventsCtrl', browseEventsCtrl);
  app.controller('venueCtrl', venueCtrl);
  app.controller('venueEventsCtrl', venueEventsCtrl);
  app.controller('venueInfoCtrl', venueInfoCtrl);
  app.controller('eventCtrl', eventCtrl);
  app.controller('faqCtrl', faqCtrl);
  app.controller('tableserviceCtrl', tableserviceCtrl);
  app.controller('errorNotFoundCtrl', errorNotFoundCtrl);
  app.controller('errorServerCtrl', errorServerCtrl);
  app.controller('checkoutCtrl', checkoutCtrl);
  app.controller('receiptCtrl', receiptCtrl);
  app.controller('signupCtrl', signupCtrl);
  app.controller('conciergeCtrl', conciergeCtrl);
  app.controller('couponsCtrl', couponsCtrl);
  app.controller('downloadCtrl', downloadCtrl);
  app.controller('earnCreditCtrl', earnCreditCtrl);
  app.controller('forgotPasswordCtrl', forgotPasswordCtrl);
  app.controller('resetPasswordCtrl', resetPasswordCtrl);
  app.controller('searchCtrl', searchCtrl);

  //curated list
  app.controller('curatedListCtrl', curatedListCtrl);
  app.controller('curatedListHalloweenCtrl', curatedListHalloweenCtrl);
  app.controller('curatedListsNewYearsCtrl', curatedListsNewYearsCtrl);
  //account
  app.controller('accountCtrl', accountCtrl);
  app.controller('accountBookingCtrl', accountBookingCtrl);
  app.controller('accountDashboardCtrl', accountDashboardCtrl);
  app.controller('accountFavoritesCtrl', accountFavoritesCtrl);
  app.controller('accountProfileCtrl', accountProfileCtrl);
  app.controller('accountPromoCtrl', accountPromoCtrl);
  app.controller('accountReviewCtrl', accountReviewCtrl);
  app.controller('accountReviewsCtrl', accountReviewsCtrl);
  app.controller('accountTicketsCtrl', accountTicketsCtrl);
  //membership
  app.controller('membershipCtrl', membershipCtrl);
  app.controller('membershipStartCtrl', membershipStartCtrl);
  app.controller('membershipLandingCtrl', membershipLandingCtrl);
  app.controller('membershipPerksCtrl', membershipPerksCtrl);
  app.controller('membershipSuccessCtrl', membershipSuccessCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/components/index.js